const analyticsEvents = {
  OPEN: 'request_form_open',
  CLOSE: 'request_form_close',
  ENTER_NAME: 'request_form_enter_name',
  ENTER_PHONE: 'request_form_enter_phone',
  INVALID: 'request_form_invalid',
  SELECT_CONTACT_TYPE: 'request_form_select_contact_type',
  SUBMIT: {
    CLICK: 'request_form_submit_click',
    ERROR: 'request_form_result_error',
    SUCCESS: 'request_form_result_success',
  },
  PROCEED: 'request_form_result_proceed',
  ERROR_SCREEN: {
    RETRY: 'request_form_result_retry',
  },
};

export const requestFormConfig = {
  analyticsEvents,
};
